/**
 配置管理--设备快速查询--模块信息
 */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import PropTypes from "prop-types";
import moment from "moment";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import PowerMoudleChargeCourse from "../stub/powerMoudleChargeCourse";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class ModuleInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.moduleInfo;
    this.initMsg();
    console.log(this.query.currentDate);
    this.state = {
      currentDate: this.query.currentDate
        ? this.query.currentDate
        : [
            moment(new Date()).subtract(0, "d").format("YYYY-MM-DD"),
            moment(new Date()).subtract(0, "d").format("YYYY-MM-DD"),
          ],
      stubId: this.query.stubId,
      eventName: this.query.eventName ? this.query.eventName : null,
    };
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  componentDidMount() {
    console.log(this.state.currentDate);
    this.setState({
      stubId: this.query.stubId,
    });
  }

  initMsg() {
    this.query = {};
    console.log(window.LayoutTab.tabParam);
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubId"] = window.LayoutTab.tabParam.stubId;
      if (window.LayoutTab.tabParam.createTime) {
        const createTime = window.LayoutTab.tabParam.createTime.split(" ")[0].split(".");
        const time = `${createTime[0]}-${createTime[1]}-${createTime[2]}`;
        const time0 = moment(new Date(time)).subtract(2, "d").format("YYYY-MM-DD");
        console.log(time0);
        this.query["currentDate"] = [time0, time];
        console.log(this.query.currentDate);
        console.log(
          moment(new Date(this.query.currentDate[0])).subtract(1, "d"),
          moment(new Date(this.query.currentDate[1])).subtract(1, "d"),
        );
      }
      if (window.LayoutTab.tabParam.eventName) {
        this.query["eventName"] = window.LayoutTab.tabParam.eventName;
      }
    }
    // if(this.query.currentDate[0])
    // let newD = new Date(this.query.currentDate[0])
    // console.log(moment(newD).subtract(1, 'd'))
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeDate",
          placeholder: this.internationalization.placeholder1, // '请选择查询起止日期',
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: this.query.currentDate
            ? [
                moment(new Date(this.state.currentDate[0])).subtract(0, "i"),
                moment(new Date(this.state.currentDate[1])).subtract(0, "i"),
              ]
            : [moment(new Date()).subtract(0, "d"), moment(new Date()).subtract(0, "d")],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            // max_val: 7 // 可选最大天数
          },
          labelName: this.internationalization.title1, // '起止日期:',
          required: !1,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              icon: "search",
              text: this.internationalization.btn1, // '查询',
              handler: (e, param) => {
                const data = [param.date.split(",")[0], param.date.split(",")[1]];
                this.setState({
                  currentDate: data,
                });
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "gird", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        stubId: this.state.stubId,
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
    };
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel">
          <PowerMoudleChargeCourse
            searchDate={this.state.currentDate}
            stubId={this.state.stubId}
            moduleChartType="2"
            eventName={this.state.eventName}
          />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ModuleInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/moduleInfo.js